import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import DocumentApprovalContMain from "presentation/view/container/DocumentApproval/DocumentApprovalContMain";

CommonEntrypoint(<DocumentApprovalContMain/>)